export default __webpack_public_path__ + "static/media/30.9265d67d.jpg";